import request from "@/utils/request";
import service from '@/utils/axios-v2';

export function login(data) {
  return service({
    url: "/fleet/login",
    data,
    method: "post",
    isNotPrompt: true
  });
}

export function forgetPassword(email) {
  return service({
    url: "/fleet/forgetPass",
    params: { email },
    isNotPrompt: true
  });
}

export function getUser() {
  return service({
    url: "/fleet/user/info/me",
    isNotPrompt: true
  });
}
export function getUserDialerStatus(){
  return service({
    url: "/command-center/user/setting/my/dialer/info",
    headers: {
      "portal-token": true,
      "system-source": "fleet",
    }
  })
}
export const getUnreadCount = () => {
  return service("/command-center/dialer/call-records/unread/count", {
    method: 'get',
    headers: {
      "Content-Type": "application/json",
      "system-source" : "fleet",
      "portal-token": true,
    },
  })
}
export function updateUserDialerStatus(data){
  return service({
    url: "/command-center/user/setting/update/switch",
    method: "post",
    data,
    headers: {
      "portal-token": true,
      "system-source": "fleet",
    }
  })
}

export function getDispatchUser() {
  return service({
    baseURL: process.env.VUE_APP_TP_URL,
    url: "/dispatcher/user/me",
    isNotPrompt: true
  });
}

export function updateUser(data) {
  return request({
    url: "/fleet/user/info/me/edit",
    method: "put",
    data,
    headers: {
      "portal-token": true
    }
  });
}

export function changePassword(email, oldPassword, newPassword) {
  return service({
    url: "/fleet/user/password_set",
    data: { email, oldPassword, newPassword },
    method: "post",
    headers: {
      "portal-token": true
    }
  });
}

export function setupUser(email, data) {
  return request({
    url: "/fleet/new_user_setup",
    method: "post",
    params: { email },
    data
  });
}

export function onBoardingEmail({ email, token, url }) {
  return request({
    url: "/fleet/user/onboard/email/send",
    method: "post",
    params: { email },
    data: url,
    headers: {
      "portal-token": token,
      "Content-Type": "text/plain"
    }
  });
}

export function onBoardingQuestion({ email, token, data }) {
  return request({
    url: "/fleet/user/invitation/questions",
    method: "post",
    params: { email },
    data,
    headers: {
      "portal-token": token
    }
  });
}

export function setTimeZone(timeZone) {
  return request({
    url: "/fleet/user/system/settings/edit",
    method: "post",
    data: { timeZone },
    headers: {
      "portal-token": true
    }
  });
}

export function setUserPhone(phone) {
  return service({
    url: '/fleet/user/info/phone/edit',
    method: 'post',
    params: { phone }
  })
}
// logout
export function fleetLogout(parameter) {
  return request({
    url: "/fleet/logout",
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
// setNotShowMessage
export function setNotShowMessage(data) {
  return service({
    url: "/fleet/user/not/show/message",
    method: "put",
    data: data,
    headers: {
      "portal-token": true,
    },
  });
}

export function getTPAuthToken() {
  return service({
    url: "/fleet/user/tp/auth-token",
    isNotPrompt: true
  });
}

export function getUsersAuthorities(params) {
  return service({
    baseURL: process.env.VUE_APP_COMMAND_CENTER,
    url: '/users/authorities/fleet',
    method: 'get',
    data: params,
    headers: {
      'portal-token': true
    },
    isNotPrompt: true
  })
}

export function newSignUp(data) {
  return service({
    url: '/fleet/register/email/send',
    method: 'post',
    data: data,
  })
}
export function temporaryToken() {
  return service({
    url: '/fleet/register/get/temporary/token',
    method: 'get'
  })
}

export function freemiumLImitNum() {
  return service({
    url: '/fleet/register/get/freemium/limit/info',
    method: 'get'
  })
}

export function registerToken(token) {
  return service({
    url: `/fleet/register/get/token/check?token=${token}`,
    method: 'get'
  })
}

export function registerPassWord(token, data) {
  return service({
    url: `/fleet/register/token/verify?token=${token}`,
    params: data,
    method: 'get'
  })
}

export function registerTrial(data) {
  return service({
    url: `/fleet/register/convert/to/trialV2`,
    data: data,
    method: 'get'
  })
}

export function fillBasicInfo(data) {
  return service({
    url: `/fleet/register/fill/basic/info`,
    data: data,
    method: 'post'
  })
}

// updateFuelCardGuide
export function updateFuelCardGuide(parameter) {
  return service({
    url: `/fleet/user/extend/update/fuel-card/guide`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}
export function updateGuide() {
  return service({
    url: `/fleet/user/extend/update/guide`,
    method: 'get'
  }) 
}

export function updateDialerGuide() {
  return service({
    url: `/fleet/user/extend/update/dialer/guide`,
    method: 'get'
  }) 
}

export function verifyUser(params) {
  return service({
    url: `/fleet/user/confirm/invite/admin`,
    method: 'get',
    params: params,
    isNotPrompt: true,
    headers: {
      'no-common-token': true
    },
  }) 
}

export function getCommodities() {
  return service({
    url: '/fleet/onboard-process/get/commodities',
    method: 'get'
  })
}
export function updateInsuranceGuide(parameter) {
  return service({
    url: `/fleet/user/extend/update/insurance/guide`,
    method: "get",
    params: parameter,
    headers: {
      "portal-token": true,
    },
  });
}

export function getTokenByTl(parameter) {
  return request({
    url: `/fleet/register/get/token`,
    method: "get",
    params: parameter,
    isNotPrompt: true,
  });
}
